import { MyNotice, MyNoticeFromJSON } from '@/api'
import * as runtime from '../runtime'

export class MyNoticeApi extends runtime.BaseAPI {
  /**
   *  ログインユーザお知らせ一覧を取得する
   *  ログインユーザお知らせ一覧取得
   */
  async getMyNotices(): Promise<MyNotice[]> {
    const response = await this.requestGet(`/my-notices`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(MyNoticeFromJSON)
    ).value()
  }
}
